export default __webpack_public_path__ + "static/media/shoppingCart.2337f981.svg";